/**
 * Specifies the creation source of Prep
 */
export enum PrepCreationSource {
  INBOUNDS = "INBOUNDS",
  REPLENISHMENT = "REPLENISHMENT",
}
